/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_FilesInputs */

const en_fc_dl_files = /** @type {(inputs: Fc_Dl_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

/**
* | output |
* | --- |
* | "Files" |
*
* @param {Fc_Dl_FilesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_files = /** @type {((inputs?: Fc_Dl_FilesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_FilesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_files(inputs)
});
export { fc_dl_files as "fc.dl.files" }